import { useEffect, useRef, useState } from 'react';
import { useTrackRec } from '../lib/trackRec';
import { useScreenMode } from '../lib/screenMode';

const AWAKE_MS = { voice: 15000, tap: 20000 };

// black power-saving cover during a live tour; GPS keeps running underneath
export default function ScreenDimmer({ t }) {
  const rec = useTrackRec(), mode = useScreenMode();
  const [dark, setDark] = useState(false);
  const timer = useRef(null);
  const live = rec?.status === 'rec' && (mode === 'voice' || mode === 'tap');
  const wakeFor = (ms) => { setDark(false); clearTimeout(timer.current); timer.current = setTimeout(() => setDark(true), ms); };
  useEffect(() => { if (!live) { setDark(false); clearTimeout(timer.current); return undefined; } wakeFor(AWAKE_MS[mode]); return () => clearTimeout(timer.current); }, [live, mode]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!live || mode !== 'voice') return undefined;
    const on = () => wakeFor(AWAKE_MS.voice);
    window.addEventListener('giss-screen-wake', on);
    return () => window.removeEventListener('giss-screen-wake', on);
  }, [live, mode]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!live || !dark) return null;
  return (
    <button type="button" className="scr-dim" data-testid="screen-dimmer" onClick={() => wakeFor(AWAKE_MS[mode])}>
      <span>{mode === 'voice' ? t.scrDimVoice : t.scrDimTap}</span>
    </button>
  );
}
